import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { orgInitialState, updatePublishAt } from 'redux/modules/composeboxForm';
import moment from 'moment';
import * as styles from './Composebox.scss';
var DraftPublishArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    timezone: state.organization.current.OrganizationTimezone && state.organization.current.OrganizationTimezone.details ? state.organization.current.OrganizationTimezone.details : {
      utc_offset: {
        hours: new Date().getTimezoneOffset() / 60
      }
    }
  };
}, {
  updatePublishAt: updatePublishAt
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(DraftPublishArea, _Component);

  var _super = _createSuper(DraftPublishArea);

  function DraftPublishArea(props) {
    var _this;

    _classCallCheck(this, DraftPublishArea);

    _this = _super.call(this, props);
    _this.state = {
      selected: props.isSchedule ? 'schedule' : 'draft',
      //publishNow
      originalPublishAt: props.publishAt ? props.publishAt : null
    };
    return _this;
  }
  /** *********************************************************
   EVENT HANDLERS
   ***********************************************************/

  /** *********************************************************
   RENDER
   ***********************************************************/


  _createClass(DraftPublishArea, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          composeboxForm = _this$props.composeboxForm,
          organizationId = _this$props.organizationId;
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(RadioButtonGroup, {
        valueSelected: this.props.composeboxForm.postTimeType,
        name: "draftMode",
        onChange: function onChange(e, val) {
          return _this2.props.onChange(val);
        },
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(RadioButton, {
        style: {
          width: 'initial',
          flex: 1
        },
        value: "publishNow",
        label: "Publish Now"
      }), /*#__PURE__*/React.createElement(RadioButton, {
        style: {
          width: 'initial',
          flex: 1
        },
        value: "schedule",
        label: "Schedule Post"
      }), /*#__PURE__*/React.createElement(RadioButton, {
        style: {
          width: 'initial',
          flex: 1
        },
        value: "draft",
        label: "Save As Draft"
      })));
    }
  }]);

  return DraftPublishArea;
}(Component)) || _class);
export { DraftPublishArea as default };